<template>
  <div class="validator-stake">
    <div class="title">
      Stake
    </div>
    <div class="stake-desc">
      Pool contract can be staked once 32ETH is matched to your node, Check <span class="pool" @click="jumpToPool">pool status</span>
    </div>

    <div v-if="currentPoolAddress == ''" class="contract">
      No Contract Addresses Founded
    </div>

    <div v-if="currentPoolAddress != ''" class="contract">
      <div class="address-desc">
        Contract Address:
      </div>
      <div class="address-dropdown">

        <span class="pool-address" @click="jumpToPoolDetail">
          {{ currentItem }}
        </span>
        <select @change="addressChange">
          <template 
            v-for="(item, index) in addressItems" >
            <option v-if="item == currentPoolAddress" :key="index" :value="item" selected="selected">{{ item }}</option>
            <option v-else :key="index" :value="item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <div class="stake-rate-item">
      <div
        :style="'width:' + currentTotalDeposit * 100 / poolTotalStake + '%;'"
        class="staking">
        <div class="staking-text">
          <div class="icon">
            <img src="../assets/eth.png" />
          </div>
          <div class="staking-amount">
            {{ currentTotalDepositShow }}
          </div>
        </div>
      </div>
      <div 
        class="capacity"/>
    </div>
    <div v-if="currentPoolStatus == 4" class="dissolve-warn">
      The pool is dissolved, please click offboard button to refund all your deposits
    </div>
    
    <div class="upload">
      <div class="upload-title">
        Upload
      </div>
      <div class="upload-desc">
        Follow the <span class="instruction" @click="jumpTo('instruction')">instruction</span> and upload your file(deposit_data-*.json)
      </div>
      <div class="upload-file" :class="{'file-color': uploadFieldName != ''}" 
        @click="currentPoolStatus != 2 && currentPoolStatus != 4 && $refs.file.click()">
        <template v-if="uploadFieldName == ''">
          {{ uploadFileDesc }}
        </template>
        <template v-else>
          {{ uploadFieldName }}
        </template>
        <input type="file" ref="file" :disabled="isSaving" @change="filesChange($event.target.files);"
            accept="application/json" class="input-file" style="display:none">
      </div>
    </div>

    <div class="operations">
      <div class="deposit-btn" :class="{'btn-active': offboardBtnActiveStatus == 1}" @click="clickOffboard">
        Offboard
      </div>
      <div class="deposit-btn" :class="{'btn-active': stakeBtnActiveStatus == 1}" @click="stake">
        Stake
      </div>
    </div>

    <DialogBtn
      v-if="dialogVisible1"
      :dialog-data="dialogData1"
      @close="offboard"
      @sure="cancel"
    />

  </div>
</template>

<script>
import StringUtil from '../util/stringUtil.js';
import NumberUtil from '../util/numberUtil.js';
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Web3Util from '../util/web3Util.js';
import LocalStorage from '../util/localStorage.js';
import DialogBtn from '../components/dialogbtn';

export default {
  name: 'validatorStake',
  components: {
    DialogBtn
  },
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      currentAddress: '',
      currentPoolAddress: '',
      currentItem: '',
      currentTotalDeposit: 0,
      currentTotalDepositShow: '0.00',
      poolTotalStake: 32,
      uploadFieldName: '',
      isSaving: false,
      clickBtn: false,
      clickOffboardBtn: false,
      dialogVisible1: false,
      dialogData1: {},
      addressItems: [],
      validatorKeys: [],
      stakeBtnActiveStatus: 0,
      offboardBtnActiveStatus: 0,
      currentPoolStatus: 0, 
      uploadFileDesc: 'Upload your file'
    }
  },

  methods: {
    jumpTo(target) {
      if (target == 'instruction') {
        window.open('https://docs.stafi.io/rproduct/reth-solution/reth-testing-guide#2-use-deposit-cli-to-generate-a-key-file');
      }
    },

    jumpToPool() {
      this.$router.push({ name: 'ethpool', params: {source: 'validatorStake', contractAddress: this.currentPoolAddress}});
    },

    jumpToPoolDetail() {
      this.$emit('jumpToPoolDetail', this.currentPoolAddress, '', 'stake');
    },

    addressChange(event) {
      let address = event.target.value;
      if (address == this.currentPoolAddress) {
        return;
      }
      LocalStorage.setCurrentEthPool(this.currentAddress, address);
      this.handleAddress(address);
      this.handleCurrentPool();
    },

    handleAddress(address) {
      this.currentPoolAddress = address;
      this.currentItem = StringUtil.replacePkh(address, 4, 38);
    },

    handleCurrentPool() {
      let web3 = Web3Util.getWeb3();
      let poolContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolAbi(), this.currentPoolAddress, {
        from: this.currentAddress
      });

      poolContract.methods.getStatus().call().then(status => {
        this.currentPoolStatus = status;
        if (status == 2) {
          this.offboardBtnActiveStatus = 0;
          this.uploadFileDesc = 'File is submitted';
        } else {
          this.uploadFileDesc = 'Upload your file';
          this.offboardBtnActiveStatus = 1;
        }
      });

      this.currentTotalDeposit = 0;

      poolContract.methods.getNodeDepositBalance().call().then(depositBalance => {
        this.currentTotalDeposit += parseFloat(web3.utils.fromWei(depositBalance, 'ether'));
        this.currentTotalDepositShow = NumberUtil.handleEthRoundToFixed(this.currentTotalDeposit);
      });

      poolContract.methods.getUserDepositBalance().call().then(depositBalance => {
        this.currentTotalDeposit += parseFloat(web3.utils.fromWei(depositBalance, 'ether'));
        this.currentTotalDepositShow = NumberUtil.handleEthRoundToFixed(this.currentTotalDeposit);
      });

      poolContract.methods.getNodeRefundBalance().call().then(depositBalance => {
        this.currentTotalDeposit += parseFloat(web3.utils.fromWei(depositBalance, 'ether'));
        this.currentTotalDepositShow = NumberUtil.handleEthRoundToFixed(this.currentTotalDeposit);
      });
    },

    clickOffboard() {
      if (this.offboardBtnActiveStatus == 0) {
        return;
      }

      this.dialogData1 = {
        icon: require('../assets/money.png'),
        lTitle: 'Confirm to offboard',
        content: 'Are your sure to offboard? All deposits will be refunded once confirm',
        type: 1,
        leftBtnText: 'Offboard',
        rightBtnText: 'Cancel'
      };
      this.dialogVisible1 = true;
    },

    cancel() {
      this.dialogVisible1 = false;
    },

    offboard() {
      if (this.clickOffboardBtn) {
        return;
      }
      this.dialogVisible1 = false;
      this.clickOffboardBtn = true;

      let web3 = Web3Util.getWeb3();
      let poolContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolAbi(), this.currentPoolAddress, {
        from: this.currentAddress
      });
      Indicator.open('Loading...');
      if (this.currentPoolStatus == 4) {
        poolContract.methods.close().send().then(result => {

          Indicator.close();
          this.clickOffboardBtn = false;

          if (result && result.status) {
            Toast({ 
              message: 'Offboard successfully', 
              duration: 3000 
            });
            setTimeout(() => {
              this.$emit('validatorOffboardSuccess');
            }, 3300);
          } else {
            Toast({ 
              message: 'Error! Please try again', 
              duration: 3000 
            });
          }
          
        }).catch((error) => {
          Indicator.close();
          this.clickOffboardBtn = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
      } else {
        poolContract.methods.dissolve().send().then(result => {
          if (result && result.status) {
            poolContract.methods.close().send().then(closeResult => {

              Indicator.close();
              this.clickOffboardBtn = false;

              if (closeResult && closeResult.status) {
                Toast({ 
                  message: 'Offboard successfully', 
                  duration: 3000 
                });
                setTimeout(() => {
                  this.$emit('validatorOffboardSuccess');
                }, 3300);
              } else {
                Toast({ 
                  message: 'Error! Please try again', 
                  duration: 3000 
                });
              }
              
            }).catch((error) => {
              Indicator.close();
              this.clickOffboardBtn = false;
              Toast({ 
                message: error.message, 
                duration: 3000 
              });
            });
          } else {
            Indicator.close();
            this.clickOffboardBtn = false;

            Toast({ 
              message: 'Error! Please try again', 
              duration: 3000 
            });
          }
        }).catch((error) => {
          Indicator.close();
          this.clickOffboardBtn = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
      }
    },

    stake() {
      if (this.stakeBtnActiveStatus == 0) {
        return;
      }

      if (this.clickBtn) {
        return;
      }
      if (this.currentPoolStatus == 2) {
        Toast({ 
          message: 'This pool contract has been staked', 
          duration: 3000 
        });
      }
      if (this.validatorKeys.length != 1) {
        return;
      }

      this.clickBtn = true;

      let web3 = Web3Util.getWeb3();
      let poolContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolAbi(), this.currentPoolAddress, {
        from: this.currentAddress
      });

      Indicator.open('Loading...');

      let pubkey = '0x' + this.validatorKeys[0].pubkey;
      poolContract.methods.stake(
        pubkey, 
        '0x' + this.validatorKeys[0].signature, 
        '0x' + this.validatorKeys[0].deposit_data_root
      ).send().then(result => {
        Indicator.close();
        this.clickBtn = false;

        if (result && result.status) {
          LocalStorage.setPoolPubKey(this.currentPoolAddress, pubkey);
          
          Toast({ 
            message: 'Stake successfully', 
            duration: 3000 
          });
          setTimeout(() => {
            this.$emit('validatorStakeSuccess');
          }, 3300);
        } else {
          Toast({ 
            message: 'Error! Please try again', 
            duration: 3000 
          });
        }
      })
      .catch((error) => {
        Indicator.close();
        this.clickBtn = false;
        Toast({ 
          message: error.message, 
          duration: 3000 
        });
      });
    },

    filesChange(files) {
      let resultFile = files[0];

      if (!resultFile) {
        Toast({ 
          message: 'Please select a file.', 
          duration: 3000 
        });
        return;
      }

      let reader = new FileReader()
      reader.readAsText(resultFile, 'UTF-8')
      reader.onload = (e) => {
        let fileContent = e.target.result
        try {
          let validatorKeys = JSON.parse(fileContent);
          if (!Array.isArray(validatorKeys)) {
            Toast({ 
              message: 'Json content must be array!', 
              duration: 3000 
            });
            return;
          }
          if (validatorKeys.length != 1) {
            Toast({ 
              message: 'There are multiple keys, please upload only one key', 
              duration: 3000 
            });
            return;
          }
          
          if (!validatorKeys[0].deposit_data_root || !validatorKeys[0].signature || 
            !validatorKeys[0].pubkey) {
            Toast({ 
              message: 'Miss deposit_data_root or signature or pubkey', 
              duration: 3000 
            });
            return;
          }
          this.uploadFieldName = resultFile.name;
          this.validatorKeys = validatorKeys;
          if (this.currentTotalDeposit >= this.poolTotalStake) {
            this.stakeBtnActiveStatus = 1;
          }
        } catch(error) {
          Toast({ 
            message: 'JSON error!', 
            duration: 3000 
          });
        }
        
      }
    }
  },

  created() {
    if (ethereum.selectedAddress) {
      this.currentAddress = ethereum.selectedAddress;
      let web3 = Web3Util.getWeb3();
      let contract = new web3.eth.Contract(Web3Util.getStafiStakingPoolManagerAbi(), Web3Util.getStafiStakingPoolManagerAddress(), {
        from: this.currentAddress
      });

      this.managerContract = contract;

      contract.methods.getNodeStakingPoolCount(this.currentAddress).call().then(poolCount => {
        if (poolCount > 0) {
          let currentPool = LocalStorage.getCurrentEthPool(this.currentAddress);
          for (let index = 0; index < poolCount; index++) {
            contract.methods.getNodeStakingPoolAt(this.currentAddress, index).call().then(poolAddress => {
              this.addressItems.push(poolAddress);
              if (currentPool) {
                if (currentPool == poolAddress) {
                  this.handleAddress(poolAddress);
                  this.handleCurrentPool();
                }
              } else if (index == poolCount - 1) {
                this.handleAddress(poolAddress);
                this.handleCurrentPool();
                LocalStorage.setCurrentEthPool(this.currentAddress, poolAddress);
              }
            });
          } 
        }
      });
    }
  }
};
</script>

<style lang="scss">

.validator-stake {

  .stake-desc {
    font-size: 16px;
    color: #C4C4C4;
    margin-top: 10px;

    .pool {
      cursor: pointer;
      color: #00F3AB;
      text-decoration: underline;
    }
  }

  .contract {
    margin-top: 30px;
    font-size: 12px;
    display: flex;

    .address-desc {
      margin-right: 10px;
    }
    
    .address-dropdown {
      display: flex;
    }

    select {
      border: none;
      background-color: #2B3239;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      outline: none;
      width: 20px;
      margin-top: -2px;
    }

    .pool-address {
      cursor: pointer;
      color: #00F3AB;
      text-decoration: underline;
    }
  }

  .stake-rate-item {
    display: flex;
    margin-top: 10px;
    width: 469px;
    height: 51px;
    border-radius: 3px;
    background: #fff;

    .staking {
      background: #00F3AB;
      line-height: 51px;
      color: #2B3239;
      font-weight: bold;
      font-size: 30px;
      border-radius: 3px;

      .staking-text {
        display: flex;
        padding-left: 10px;

        .icon {
          margin-top: 7px;
          margin-right: 5px;
          height: 36px;
          img {
            height: 100%;
          }
        }

      }
      
    }

    .capacity {
      background: #fff;
    }
  }

  .dissolve-warn {
    margin-top: 5px;
    color: #FF6464;
    font-size: 13px;
  }

  .upload {
    margin-top: 50px;

    .upload-title {
      font-size: 26px;
      font-weight: bold;
    }

    .upload-desc {
      margin-top: 11px;
      font-size: 16px;
      color: #C4C4C4;

      .instruction {
        cursor: pointer;
        color: #00F3AB;
        text-decoration: underline;
      }
    }

    .upload-file {
      cursor: pointer;
      margin-top: 20px;
      width: 469px;
      height: 119px;
      line-height: 119px;
      background: #fff;
      text-align: center;
      font-size: 16px;
      color: #C4C4C4;
      border-radius: 3.65px;
    }

    .file-color {
      color: #00F3AB;
    }
  }

  .operations {
    display: flex;
    margin-left: 210px;

    .deposit-btn {
      cursor: pointer;
      margin-left: 20px;
      width: 110px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      color: #23292F;
      font-weight: bold;
      background-color: #00F3AB;
      border-radius: 21px;
      text-align: center;
      margin-top: 20px;
      opacity: 0.4;
    }

    .btn-active {
      opacity: 1;
    }
  }

  
}
  
</style>